import {
  ADD_TO_MERGE_LIST,
  CREATE_SPARE_PART_SUCCESS,
  FETCH_SPARE_PART_SUCCESS,
  GET_ALL_SPARES_START,
  GET_ALL_SPARES_SUCCESS,
  GET_SPARE_COMPATIBLE_SUCCESS,
  GET_SPARE_FOR_SUBASSEMBLY_SUCCESS,
  GET_SPARE_PART_SUCCESS,
  SAVE_SPARE_PART_QUERY,
  SPARE_NAME_GENERATE_CLEAR,
  SPARE_NAME_GENERATE_SUCCESS
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  allSparesLoading: false,
  allSpares: [],
  mergeableSpares: [],
  generatedSpareName: '',
  submitPayload: null,
  compatibleSpares: [],
  subAssemblySpares: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SPARE_PART_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_SPARE_PART_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_SPARE_PART_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_SPARE_PART_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case GET_ALL_SPARES_START: {
      return {
        ...state,
        allSparesLoading: true
      };
    }

    case GET_ALL_SPARES_SUCCESS: {
      return {
        ...state,
        allSparesLoading: false,
        allSpares: action.data
      };
    }

    case ADD_TO_MERGE_LIST: {
      return {
        ...state,
        mergeableSpares: action.data,
      }
    }

    case SPARE_NAME_GENERATE_SUCCESS: {
      return {
        ...state,
        generatedSpareName: action.name,
        submitPayload: action.data,
      }
    }

    case SPARE_NAME_GENERATE_CLEAR: {
      return {
        ...state,
        generatedSpareName: '',
        submitPayload: null,
      }
    }

    case GET_SPARE_COMPATIBLE_SUCCESS: {
      return {
        ...state,
        compatibleSpares: action.data,
      }
    }

    case GET_SPARE_FOR_SUBASSEMBLY_SUCCESS: {
      return {
        ...state,
        subAssemblySpares: action.data,
      }
    }

    default:
      return state;
  }
}
